module.exports = __webpack_public_path__ + "img/40_38_075_890.69cd9778.jpg";